import { useState, useEffect } from 'react';
import { useRoom } from '../../../contexts/RoomContext';
import { BACKEND_URL } from '../../../services/authService';

export default function NowPlayingSettings() {
  const { currentRoom, refetchRoom } = useRoom();
  const [enabled, setEnabled] = useState(currentRoom?.nowPlayingAnnouncementsEnabled ?? true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (currentRoom?.nowPlayingAnnouncementsEnabled !== undefined) {
      setEnabled(currentRoom.nowPlayingAnnouncementsEnabled);
    }
  }, [currentRoom]);

  const handleEnabledChange = async () => {
    const newValue = !enabled;
    setEnabled(newValue);
    setLoading(true);
    try {
      const response = await fetch(
        `${BACKEND_URL}/room/setNowPlayingAnnouncementsEnabled?nowPlayingAnnouncementsEnabled=${newValue}`, 
        {
          method: 'POST',
          credentials: 'include'
        }
      );
      if (!response.ok) throw new Error('Failed to update now playing announcements setting');
      await refetchRoom();
    } catch (e) {
      console.error('Error updating now playing announcements setting:', e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-white">Now Playing Announcements</h3>
      <div className="p-4 rounded-lg bg-[#2E2E2E] border border-gray-700">
        <div className="flex items-center">
          <div className="flex-1">
            <p className="text-sm text-gray-300">Enable Now Playing Announcements</p>
            <p className="text-xs text-gray-400 mt-1">
              The bot will announce when a new song starts playing in chat
            </p>
          </div>
          <button
            onClick={handleEnabledChange}
            disabled={loading}
            className={`px-3 py-1 rounded text-sm ${
              enabled ? 'bg-green-600 hover:bg-green-700' : 'bg-gray-600 hover:bg-gray-700'
            } text-white transition-colors disabled:opacity-50`}>
            {enabled ? 'Enabled' : 'Disabled'}
          </button>
        </div>
      </div>
    </div>
  );
}
